import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { MessageManagementService } from './message-management.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService,
    private router: Router,
    private notificationService: MessageManagementService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('assets/i18n/')) { return next.handle(req); }
    const urlBase = req.headers.get('urlBase');
    let headersNew = new HttpHeaders();

    req.headers.keys().forEach(key => {
      if (key !== 'urlBase') {
        headersNew = headersNew.append(key, req.headers.get(key));
      }
    });

    if (this.authService.tokenExpired()) {
      this.notificationService.error('Token Expiró');
      this.authService.logAuth(this.authService.user.clientCode);
    }

    const authorizedRequest = req.clone({
      headers: headersNew.append('Authorization', `Bearer ${this.authService.token}`),
    });
    return next.handle(authorizedRequest).pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      //navigate /delete cookies or whatever
      this.notificationService.error("No estas autorizado para realizar esta accion");
      this.router.navigate(['/auth/login', this.authService.user.clientCode]);
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message); // or EMPTY may be appropriate here
    }
    return throwError(err);
  }

}
